import { REPORTS_BASE_ROUTE, TABS } from '@/src/utils/constants'
import { Suspense, lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'
const ReportingScreenLazy = lazy(() => import('./ReportingScreen.page'))

const ReportsOverviewLazy = lazy(() => import('./ReportsOverview'))
const ReportDetailLazy = lazy(() => import('./ReportDetail/ReportDetail'))
const ReportPdfViewLazy = lazy(() => import('./ReportPdfView/ReportPdfView'))
const SentReportDetailLazy = lazy(() => import('./SentReportDetail/SentReportDetail'))

const ReportingScreenPage = (
  <Suspense fallback={<div></div>}>
    <ReportingScreenLazy />
  </Suspense>
)

const ReportsOverviewgPage = (
  <Suspense fallback={<div />}>
    <ReportsOverviewLazy />
  </Suspense>
)

const ReportDetailPage = (
  <Suspense fallback={<div />}>
    <ReportDetailLazy />
  </Suspense>
)

const SentReportDetailPage = (
  <Suspense fallback={<div />}>
    <SentReportDetailLazy />
  </Suspense>
)

const ReportPdfViewPage = (
  <Suspense fallback={<div />}>
    <ReportPdfViewLazy />
  </Suspense>
)

export const getReportsRoutes = (): RouteObject[] => {
  const defaultRedirection = TABS.reports.overview

  return [
    // PDF route - must be outside AuthRoute for PDF generation
    {
      path: `${REPORTS_BASE_ROUTE}/:reportId/pdf-view`,
      element: ReportPdfViewPage,
    },
    {
      path: REPORTS_BASE_ROUTE,
      element: (
        <AuthRoute>
          <LayoutMain />
        </AuthRoute>
      ),
      children: [
        { path: '', element: <Navigate to={defaultRedirection} replace /> },
        {
          path: TABS.reports.overview,
          element: ReportingScreenPage,
          children: [
            { path: '', element: ReportsOverviewgPage },
            { path: ':reportId', element: ReportDetailPage },
            { path: ':reportId/sent-reports/:sentReportId', element: SentReportDetailPage },
          ],
        },
      ],
    },
  ]
}
